import { render, staticRenderFns } from "./incomeDetail.vue?vue&type=template&id=106cc0c0&"
import script from "./incomeDetail.vue?vue&type=script&lang=js&"
export * from "./incomeDetail.vue?vue&type=script&lang=js&"
import style0 from "./incomeDetail.vue?vue&type=style&index=0&id=106cc0c0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports